import React, { Component } from "react";
import ExistingForms from "./ExistingForms";
import ExistingQuestion from "./ExistingQuestion";

class QuestionSideBar extends Component {
    state = {
        // isExisting: true,
        // formOptions: [
        //     { title: "Existing properties", className: "existing-forms" },
        //     { title: "Create new", className: "new-form" }
        // ],
        // activeTab: 0
    };

    // switchTab = (index) => {
    //     this.setState({ activeTab: index })
    // }

    render() {

        const { formItems, hideHandlers, showhandlers } = this.props;
        const { isExisting, formOptions } = this.state;
        return (
            <div className="form-column formItems-container h-100" >
                <ExistingQuestion
                    hideHandlers={hideHandlers}
                    showhandlers={showhandlers}
                    formItems={formItems}
                    onSave={this.props.onSave}
                    lastStage={this.props.lastStage}
                    saveTitle={this.props.saveTitle}
                    page={this.props.page}
                    language={this.props.language}
                />

            </div>
        );
    }
}

export default QuestionSideBar;
